var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CharacteristicEdit", {
    attrs: {
      value: _vm.value,
      title: "Steuertätigkeiten",
      "sub-title":
        "Je genauer du die Aufgaben beschreibst, desto attraktiver wird die Aufgabe für InteressentInnen.",
      "with-keyword": "",
      "characteristic-items": _vm.meta.functionTaxRole,
      "characteristic-type": _vm.meta.functionTaxRoleType,
      "nothing-allowed": {
        onlyOverall: true,
        overall: {
          inFan: true,
          text: "Keine der zur Auswahl stehenden"
        }
      },
      "supplements-config": {
        disable: true
      },
      "selected-items-config": {
        showExperience: false
      },
      "label-type": "job-profile",
      "open-fan-button-alignment": "left",
      "open-fan-label": "Hinzufügen",
      "open-fan-label-with-selection": "Bearbeiten"
    },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }